import arrow from "@assets/redesign/icons/arrowLeft.svg";
import trash from "@assets/redesign/icons/trash.svg";
import Icon from "@components/global/new/Icon/Icon";
import PlanTime from "@components/global/new/PlanTime/PlanTime";
import Title from "@components/global/new/Title/Title";
import { MODALS_ENUM } from "@constants/Modals";
import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import {
  ITemplateMetaWithColor,
  usePlanCreatorContext,
} from "../PlanCreatorContext";
import styles from "./PlanTemplate.module.scss";
import classNames from "classnames";

export default function PlanTemplate() {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const {
    disabled,
    readOnly,
    plan,
    templates,
    setPeriodsWithTemplate,
    deleteTemplatesByPlanId,
  } = usePlanCreatorContext();

  const [myTemplate, setMyTemplate] = useState<ITemplateMetaWithColor>();

  useEffect(() => {
    if (plan) {
      setMyTemplate(undefined);
      let result: ITemplateMetaWithColor;
      for (let i = 0; i < templates.length; i++) {
        if (templates[i].planId === plan.id && templates[i].times.length > 0) {
          result = {
            color: templates[i].color,
            periods: [],
          };
          for (let j = 0; j < templates[i].times.length; j++) {
            if (templates[i].times[j].length > 1) {
              result.periods.push([
                templates[i].times[j][0],
                templates[i].times[j][1],
              ]);
            }
          }
          setMyTemplate(result);
          break;
        }
      }
    }
  }, [templates, plan]);

  const onAplyTemplate = useCallback(() => {
    if (myTemplate) setPeriodsWithTemplate(myTemplate);
  }, [myTemplate]);

  const onDeleteTemplate = useCallback(async () => {
    if (plan) {
      dispatch(
        show(MODALS_ENUM.CONFIRM_MODAL, {
          title: formatMessage({
            id: "manage.plan_info.template.delete_confirm",
          }),
          onConfirm() {
            (async () => {
              await deleteTemplatesByPlanId(plan?.id);
              setMyTemplate(undefined);
            })();
          },
        })
      );
    }
  }, [plan, templates]); // templates for deleteTemplatesByPlanId

  if (!myTemplate || readOnly || !plan) return null;

  return (
    <div className={styles.wrapper}>
      <Title className={styles.title}>
        {formatMessage({ id: "manage.plan_info.template.title" })}
      </Title>

      <div className={classNames(styles.template_box, {
        [styles.outlined]: !disabled,
      })}>
        <div className={styles.content}>
          {myTemplate &&
            myTemplate.periods.map((pick, i) => (
              <PlanTime key={i} hh_12={false} value={pick} idx={i} disabled />
            ))}
        </div>
        <div>
          <div className={styles.title_wrapper}>
            {myTemplate && (
              <div
                className={styles.color}
                style={{ backgroundColor: myTemplate.color }}
              ></div>
            )}
            <Icon src={trash} className={styles.trash} noHover onClick={onDeleteTemplate} />
            {!disabled && <Icon src={arrow} className={styles.arrow} noHover onClick={onAplyTemplate} />}
          </div>
        </div>
      </div>
    </div>
  );
}
